import React from 'react';
import NavbarComponent from '../pages/Navbar';
import Footer from '../Footer';
import CommitmentSection from "../CommitmentSection";
import WedBanner from './WedBanner';
import WeddingInfo from './WeddingInfo';


const WeddingManagementDetails = () => {
  return (
    <>
      <NavbarComponent />
      <WedBanner/>
      <CommitmentSection />
      <WeddingInfo/>
      
      <Footer />
    </>
  );
};

export default WeddingManagementDetails;
